import { connect } from 'react-redux';
import View from './AccountsStepView';
import { viewIdSelector } from './AccountsStepSelector';
import {
  iterator,
  currentClientIdOrDefaultSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { fetchDataIfNecessary } from '../../../AdvWorkflow/AdvWorkflowCacheActions';
import dirtyNodesMapSelector from '../../../AdvWorkflow/AdvWorkflowCacheSelector';

const mapStateToProps = (state, ownProps) => ({
  viewId: viewIdSelector(state, ownProps),
  clientId: currentClientIdOrDefaultSelector(state, ownProps),
  iterator: iterator(state, ownProps),
  dirtyNodesMap: dirtyNodesMapSelector(state, ownProps),
});
const mapDispatchToProps = dispatch => ({
  fetchData: (workflowId, clientId, dirtyNodesMap) => {
    dispatch(fetchDataIfNecessary(
      workflowId,
      clientId,
      ['DebtAccounts', 'MortgageTypeOptions', 'DebtAccountTypes', 'AccountOwners'],
      dirtyNodesMap,
      false,
    ));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
